import { render, staticRenderFns } from "./KusCardRemoveBtn.vue?vue&type=template&id=3bb511c8"
import script from "./KusCardRemoveBtn.vue?vue&type=script&lang=js"
export * from "./KusCardRemoveBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports